import { useMemo } from 'react';

const displayCountTimer = (secondsLeft) => {
  const timer = useMemo(() => {
    const date = new Date(secondsLeft * 1000);
    let mm = date.getUTCMinutes();
    let ss = date.getSeconds();

    // These lines ensure to have two-digits
    if (mm < 10) {
      mm = 0 + mm;
    }
    if (ss < 10) {
      ss = 0 + ss;
    }

    // This formats to HH:MM:SS
    const t = mm + ':' + ss;
    return t;
  }, [secondsLeft]);

  return timer;
};

export default displayCountTimer;
